<template>
    <div>
        <h2>{{ store.lexicon[store.culture].PRFormRequestBkg }}</h2>

        <div class="row">
            <div class="mb-3 col-sm-6">
                {{ store.lexicon[store.culture].PRFormRequestBkg1 }}
                <span class="required">*</span>
                <div class="custom-control custom-radio">
                    <input type="radio" id="customRadio1" v-model="store.formData.ForGovernment" value="1" class="custom-control-input" @change="validatePage('BACKGROUND', 'forGovernment')">
                    <label class="custom-control-label" for="customRadio1">{{ store.lexicon[store.culture].Yes }}</label>
                </div>
                <div class="custom-control custom-radio">
                    <input type="radio" id="customRadio2" v-model="store.formData.ForGovernment" value="0" class="custom-control-input" @change="validatePage('BACKGROUND', 'forGovernment')">
                    <label class="custom-control-label" for="customRadio2">{{ store.lexicon[store.culture].No }}</label>
                </div>
                <div v-if="store.errors.ForGovernment" class="error">{{ store.lexicon[store.culture].AnswerRequired }}</div>
            </div>
        </div>

        <div class="row">
            <div class="mb-3 col-sm-6">
                {{ store.lexicon[store.culture].PRFormRequestBkg5 }}
                <span class="required">*</span>
                <div class="custom-control custom-radio">
                    <input type="radio" id="customRadio3" v-model="store.formData.ForMedia" value="1" class="custom-control-input" @change="validatePage('BACKGROUND', 'forMedia')">
                    <label class="custom-control-label" for="customRadio3">{{ store.lexicon[store.culture].Yes }}</label>
                </div>
                <div class="custom-control custom-radio">
                    <input type="radio" id="customRadio4" v-model="store.formData.ForMedia" value="0" class="custom-control-input" @change="validatePage('BACKGROUND', 'forMedia')">
                    <label class="custom-control-label" for="customRadio4">{{ store.lexicon[store.culture].No }}</label>
                </div>
                <div v-if="store.errors.ForMedia" class="error">{{ store.lexicon[store.culture].AnswerRequired }}</div>
            </div>
        </div>

        <div class="row">
            <div class="mb-3 col-sm-6">
                {{ store.lexicon[store.culture].PRFormRequestBkg8a }}
                <span class="required">*</span>
                <div class="custom-control custom-radio">
                    <input type="radio" id="customRadio5" v-model="store.formData.ForLegal" value="1" class="custom-control-input" @change="validatePage('BACKGROUND', 'forLegal')">
                    <label class="custom-control-label" for="customRadio5">{{ store.lexicon[store.culture].Yes }}</label>
                </div>
                <div class="custom-control custom-radio">
                    <input type="radio" id="customRadio6" v-model="store.formData.ForLegal" value="0" class="custom-control-input" @change="validatePage('BACKGROUND', 'forLegal')">
                    <label class="custom-control-label" for="customRadio6">{{ store.lexicon[store.culture].No }}</label>
                </div>
                <div v-if="store.errors.ForLegal" class="error">{{ store.lexicon[store.culture].AnswerRequired }}</div>
            </div>
        </div>

        <div class="d-flex justify-content-center">
            <button type="button" class="btn btn-outline-primary me-2" @click="goBackToPage('REQUESTOR')">{{ store.lexicon[store.culture].Back }}</button>
            <button type="button" class="btn btn-primary" @click="goToPage('TYPE')">{{ store.lexicon[store.culture].Next }}</button>
        </div>
    </div>
</template>

<script setup>
    import { useStore } from './store.js';

    const emit = defineEmits(['goToPage', 'goBackToPage', 'validatePage']);

    const store = useStore();

    function goToPage(pageName) {
        emit('goToPage', pageName);
    }

    function goBackToPage(pageName) {
        emit('goBackToPage', pageName);
    }

    function validatePage(pageName, fieldName) {
        emit('validatePage', pageName, fieldName);
    }

</script>